module.exports = __webpack_public_path__ + "img/201709-1-768x1024.41a003bc.jpeg";